import { FormattedMessage } from "react-intl";
import TelegramIcon from "@mui/icons-material/Telegram";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const style = {
	actWrapper: `py-4 lg:basis-1/2`,
	titleWrapper: `mb-4`,
	title: `relative ml-6 lg:ml-0 text-lg text-white mb-4`,
	ctaBtnBlock: `relative mb-8 flex items-center justify-center w-[300px]`,
	click: `absolute w-[25px] h-[35px] -rotate-12 right-0 top-[50%] animate-ping pointer-events-none`,
	ctaBtn: `bg-blue flex items-center text-md justify-center py-2 text-white w-full rounded-lg transition hover:shadow-[0_10px_25px_0_#4430D0]`,
	payme: `w-[70px] mr-4`,
	courseLogo: `flex items-center mb-8`,
	circle: `w-[70px] duration-3s animate-spin-slow`,
	restart: `w-[200px]`,
	attention: `flex ml-4 lg:ml-0 items-center`,
	excl: `text-red mr-2`,
	telegram: `text-[#0088CC] mr-2`,
	centerBlock: `flex justify-center lg:block`,
	price: `text-md w-[300px] text-center text-black py-5 bg-lime my-4 w-fit rounded-full`,
	summ: `text-4xl`,
};

const Action = () => {
	return (
		<div className={style.actWrapper}>
			<div className={style.courseLogo}>
				<img
					className={style.circle}
					src='./images/restartCircle.png'
					alt='circle'
				/>
				<img
					className={style.restart}
					src='./images/restartText.png'
					alt='Restart'
				/>
			</div>
			<div className={style.titleWrapper}>
				<h3 className={style.title}>
					<FormattedMessage id='cta-one' />
				</h3>
				<h3 className={style.title}>
					<FormattedMessage
						id='cta-two'
						values={{
							b: (chunks) => (
								<strong style={{ color: "#DAF66A" }}>{chunks}</strong>
							),
						}}
					/>
				</h3>
				<div className={style.centerBlock}>
					<p className={style.price}>
						<span className={style.summ}>7 777 777</span>
						<FormattedMessage id='price' />
					</p>
				</div>
				<div className={style.centerBlock}>
					<div className={style.ctaBtnBlock}>
						<img
							src='./images/click.webp'
							className={style.click}
							alt='click'
						/>
						<a
							href='#'
							target='_blank'
							rel='noreferrer'
							className={style.ctaBtn}
						>
							<span>
								<img
									className={style.payme}
									src='./images/paymeWhite.webp'
									alt='payme'
								/>
							</span>
							<FormattedMessage id='payme' />
						</a>
					</div>
				</div>

				<div className={style.attention}>
					<ErrorOutlineIcon className={style.excl} />
					<p>
						<FormattedMessage id='recommendation' />
					</p>
				</div>
				<div className={style.attention}>
					<TelegramIcon className={style.telegram} />
					<p>
						<FormattedMessage id='telegram' />
					</p>
				</div>
				<div className={style.attention}>
					<ErrorOutlineIcon className={style.excl} />
					<p>
						<FormattedMessage id='time' />
					</p>
				</div>
			</div>
		</div>
	);
};

export default Action;
